<ng-container *ngIf="modalOptions" >
  <div class="cardv2-header">
    <div>
      <span *ngIf="!modalOptions.MessageType">{{modalOptions.Title}}</span>
      <span i18n *ngIf="modalOptions.MessageType === messageTypes.MakeAvailableOffline">Offline Report</span>
      <span i18n *ngIf="modalOptions.MessageType === messageTypes.MakUnavailableOffline">Disable Offline Report</span>
    </div>
  </div>
</ng-container>
